import { VisaStatesEnum } from '../enums/visa-states.enum';
import { DocumentValidationInterface } from '../interfaces/document-validation.interface';
import { DocumentVisaInterface } from '../interfaces/document-visa.interface';
import { ValidationCommentInterface } from '../interfaces/validation-comment.interface';
import { DocumentValidation } from './document-validation.model';
import { ValidationComment } from './validation-comment.model';

export class DocumentVisa {
  /**
   * Id.
   */
  id: number;

  /**
   * Description.
   */
  description: string;

  /**
   * Document Id.
   */
  documentId: number;

  /**
   * State.
   */
  state: VisaStatesEnum;

  /**
   * Deadline.
   */
  deadline: number;

  /**
   * Validations.
   */
  validations: DocumentValidation[];

  /**
   * Comments.
   */
  comments: ValidationComment[];

  /**
   * DocumentVisa visa.
   *
   * @param data Document visa.
   */
  constructor(data: DocumentVisaInterface) {
    this.id = data.id;
    this.description = data.description;
    this.documentId = data.document_id;
    this.state = data.status;
    this.deadline = new Date(data.deadline).getTime() / 1000;
    this.validations = data.validations?.map(
      (validation: DocumentValidationInterface) => new DocumentValidation(validation)
    );
    this.comments = data?.comments.map((comment: ValidationCommentInterface) => new ValidationComment(comment));
  }
}
